export default "__VITE_ASSET__DwZ0oGC4__"